import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-add-to-home-dialog',
	templateUrl: './add-to-home-dialog.component.html',
	styleUrls: ['./add-to-home-dialog.component.scss']
})
export class AddToHomeDialogComponent implements OnInit {

	browser: string;
	translateContext = TranslateContext;

	constructor(public dialogRef: MatDialogRef<AddToHomeDialogComponent>) {
	}

	ngOnInit() {
	}

	close(isNotShow: boolean) {
		this.dialogRef.close(isNotShow);
	}

}
